import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags'
import React, { useState, useRef } from 'react'
import './styles.css'

import { Row, Col, Alert } from 'reactstrap'
import { Redirect } from 'react-router-dom'

import { AvForm, AvField } from 'availity-reactstrap-validation'
import { createUser } from '../../store/auth/login/actions'
import { useUserInfo } from 'context/userContext'
import { AuthSplitShell } from './AuthSplitShell'

const Register = ({ match }) => {
  const { setUserName } = useUserInfo()

  const idIndicacao = match?.params?.indicacao

  const [submitting, setSubmitting] = useState(false)
  const submitLock = useRef(false)
  const [login, setLogin] = useState(false)
  const [error, setError] = useState(false)
  const [message, setMessage] = useState('')

  const handleValidSubmit = async (event, values) => {
    if (submitLock.current) return
    submitLock.current = true
    setSubmitting(true)
    try {
      const payload = {
        ...values,
        indicacao: idIndicacao
      }
      const result = await createUser(payload)

      if (result.status === 200) {
        setError(false)
        setMessage('')
        setUserName(result.userName)
        setLogin(true)
      } else {
        setLogin(false)
        setError(true)
        setMessage(result.message)
      }
    } catch (err) {
      // mantém formulário habilitado após erro de rede
    } finally {
      submitLock.current = false
      setSubmitting(false)
    }
  }

  if (login) {
    return <Redirect to="/assinaturas" />
  }

  return (
    <>
      <MetaTags>
        <title>Registro | Zap+</title>
      </MetaTags>
      <AuthSplitShell
        mode="signup"
        wideLeft
        title={
          <>
            Sua operação no{' '}
            <span className="auth-split__accent">WhatsApp</span>, no controle.
          </>
        }
        subtitle="Preencha os dados da empresa. Depois você escolhe sua assinatura."
      >
        <div className="auth-split__form-card">
          <AvForm
            className="auth-dark__form"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}
          >
            {error && (
              <Alert color="danger" className="auth-dark__alert mb-3">
                {message}
              </Alert>
            )}
            <fieldset
              disabled={submitting}
              className="auth-split__fieldset"
            >
            <Row className="g-3">
              <Col xs={12} md={6}>
                <AvField
                  name="name"
                  label="Nome"
                  value=""
                  className="form-control auth-dark__control"
                  placeholder="Nome da empresa"
                  type="text"
                  required
                />
              </Col>
              <Col xs={12} md={6}>
                <AvField
                  name="email"
                  label="Email"
                  value=""
                  className="form-control auth-dark__control"
                  placeholder="Insira o email"
                  type="email"
                  required
                />
              </Col>
              <Col xs={12} md={6}>
                <AvField
                  name="password"
                  label="Senha"
                  value=""
                  type="password"
                  required
                  placeholder="Insira a senha"
                  className="form-control auth-dark__control"
                />
              </Col>
              <Col xs={12} md={6}>
                <AvField
                  name="cnpj"
                  label="CNPJ"
                  value=""
                  className="form-control auth-dark__control"
                  placeholder="Insira o CNPJ"
                  type="text"
                  required
                />
              </Col>
              <Col xs={12} md={6}>
                <AvField
                  name="responsavel"
                  label="Responsável"
                  value=""
                  className="form-control auth-dark__control"
                  placeholder="Nome do responsável"
                  type="text"
                  required
                />
              </Col>
              <Col xs={12} md={6}>
                <AvField
                  name="contato"
                  label="Telefone"
                  value=""
                  className="form-control auth-dark__control"
                  placeholder="Telefone para contato"
                  type="text"
                  required
                />
              </Col>
            </Row>
            <button
              type="submit"
              className="btn auth-dark__btn-primary auth-dark__btn-primary--with-spinner w-100 mt-4"
              aria-busy={submitting}
            >
              {submitting ? (
                <>
                  <span className="auth-btn-spinner" aria-hidden />
                  Criando conta…
                </>
              ) : (
                'Criar conta'
              )}
            </button>
            </fieldset>
          </AvForm>
        </div>
      </AuthSplitShell>
    </>
  )
}

export default Register

Register.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func
}
